exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "project-pipeline {\n  display: block;\n}\nproject-pipeline a {\n  color: var(--color-mineshaft);\n  text-decoration: none;\n}\nproject-pipeline .execution-title {\n  font-weight: 600;\n  display: inline-block;\n  margin: 5px 0 0 0;\n}\nproject-pipeline .build-label.execution-build-number {\n  display: none;\n}\nproject-pipeline a.execution-build-number {\n  display: inline;\n}\nproject-pipeline .execution-bar {\n  width: 100%;\n  padding-top: 0;\n}\nproject-pipeline .execution-bar .stage {\n  display: inline-block;\n  height: 15px;\n  opacity: 0.65;\n}\nproject-pipeline .execution-bar .stage:hover {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/projects/dashboard/pipeline/projectPipeline.less
// module id = 3335
// module chunks = 0